import './modules/swiper';
import './modules/jobLoadMore';
import './modules/featuresTabs';
import './utils/referencesGrid';
import './modules/blogFilter';
import './modules/counter';
import './modules/fslightbox';
import './modules/header-nav';
import './modules/copy-link-blog-post';
import './modules/job-offer-section';
import './modules/webinar-modal';
import './modules/language-flag';
import './modules/close-notification-cf7';
import './modules/handle-job-offer-form';
import { initSmoothScroll } from './modules/smooth-scroll-lenis';
import './modules/our-values.js';

// Initialize any JavaScript functionality here
document.addEventListener('DOMContentLoaded', () => {
  console.log('App initialized');
  
  initSmoothScroll();
});
